import { ChevronRight } from '@tbd/life-jsx/SystemIcons';
import { PrimaryButton } from '@tbd/lift-ui/components/PrimaryButton';
import type { PrimaryButtonProps } from '@tbd/lift-ui/components/PrimaryButton';

export function NextButton(props: Omit<PrimaryButtonProps, 'text'>) {
  return (
    <PrimaryButton
      text="Next"
      href={props.href}
      icon={<ChevronRight />}
      iconPosition="end"
      {...props}
    />
  );
}
